<div class="flex min-h-screen text-gray-100 font-sans">
  <!-- Columna izquierda -->
  <aside class="w-64 flex flex-col">
    <!-- Logo -->
    <!-- Menú lateral -->
    <nav class="flex-1 overflow-y-auto">
      <app-sidebar></app-sidebar>
    </nav>
  </aside>

  <!-- Columna derecha -->
  <div class="flex-1 flex flex-col bg-gray-300">
    <!-- Barra superior (usuario/configuración) -->
    <header class="h-16 bg-gray-800 flex items-center justify-end px-4">
      <app-topbar></app-topbar>
    </header>

    <!-- Contenido principal -->
    <main class="flex-1 p-6 overflow-y-auto h-full">
      <router-outlet *ngIf="showOutlet"></router-outlet>
    </main>
  </div>
</div>